import { cloneDeep } from 'lodash'

import * as actions from '../actions/SystemMessageActions'

export default (state = actions.SYSTEM_MESSAGE_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case actions.SYSTEM_MESSAGE_CANCELED: {
      return cloneDeep(actions.SYSTEM_MESSAGE_INITIAL_STATE)
    }
    case actions.SYSTEM_MESSAGE_SHOW: {
      return Object.assign(cloneDeep(state), action.payload, { show: true })
    }
    default:
  }
  return state
}
